import util from '../utils/index'
let menuList = [
    {
        title: {
            'zh-CN': '主面板',
            en: 'Main Panel',
        },
        id: 1,
        props: {
            to: '/home/panel'
        },
    },
    {
        title: {
            'zh-CN': '我的资料',
            en: 'My Profile',
        },
        id: 2,
        props: {
            to: '/home/profile'
        },
    },
    {
        title: {
            'zh-CN': '账户安全',
            en: 'Account Sercurity'
        },
        id: 3,
        props: {
            to: '/home/sercurity'
        }
    },
    {
        title: {
            'zh-CN': '修改密码',
            en: 'My Edit Password',
        },
        id: 4,
        props: {
            to: '/home/password'
        },
    },
    {
        title: {
            'zh-CN': '绑定社交账号',
            en: 'Social Account Binding',
        },
        id: 5,
        props: {
            to: '/home/connections'
        },
    },
    {
        title: {
            'zh-CN': '切换为用户身份',
            en: 'Act As A User',
        },
        id: 6,
        props: {
            to: '/home/actas'
        },
    },

]
// 检测是否展示社交登录
if (!util.checkSocialLogin(window.location.host)) {
    // 去除社交登录菜单
    menuList.splice(menuList.length - 2, 1);
}
export default {
    state: {
        staticMenulist: menuList,
        loginData: JSON.parse(localStorage.LOGINDATA || '{}')
    },
    getters: {
        getStaticMenulist(state, getters) {
            return getters.isSuper ? state.staticMenulist : state.staticMenulist.slice(0, 5)
        },
    },
    mutations: {

        setLoginData(state, payload = {}) {
            if (!payload.save) payload.save = false;
            localStorage.LOGINDATA = JSON.stringify(payload)
            state.loginData = payload;
        },
    },
}
